
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import DataTable from 'react-data-table-component';
import {
    Button,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    UncontrolledDropdown,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Container,
} from 'reactstrap';

import {
    PlusCircle,
    MoreVertical,
    CheckCircle,
    Edit,
    Trash2
} from 'react-feather';
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import { baseURL, getPublicS3Url } from '../../../../Services/api/baseURL';
import Loader from '../../../Loader/Loader';
import { FaPen, FaTrash, FaTrashAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router';


const ProductsTable = () => {
    // State Management
    const navigate = useNavigate();
    const [products, setProducts] = useState({
        data: [],
        loading: false,
        totalRows: 0,
        perPage: 10,
        currentPage: 1
    });

    const [subCategories, setSubCategories] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [category, setCategory] = useState([]);
    const [modal, setModal] = useState({
        isOpen: false,
        type: 'add',
        selectedProduct: null
    });

    // Authentication - Get fresh token each time
    const token = React.useMemo(() => {
        const t = localStorage.getItem('token');
        return t ? JSON.parse(t) : null;
    }, []);

    const userRole = React.useMemo(() => {
        const r = localStorage.getItem('role_name');
        return r ? JSON.parse(r) : null;
    }, []);

    // Fetch Products (client-side pagination)
    const fetchProducts = async () => {
      setProducts(prev => ({ ...prev, loading: true }));
      try {
        const response = await axios.get(`${baseURL}/api/product`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log('API Response:', response.data); // Debug log

        // Check if response.data is an array or object with data property
        let productsArray = [];

        if (Array.isArray(response.data)) {
          productsArray = response.data;
        } else if (response.data?.data && Array.isArray(response.data.data)) {
          productsArray = response.data.data;
        } else if (response.data?.products && Array.isArray(response.data.products)) {
          productsArray = response.data.products;
        }

        // Transform each product's productDetails into key-value pairs
        const formattedData = productsArray.map(product => ({
          ...product,
          productDetails: product.productDetails
            ? Object.entries(product.productDetails).map(([key, value]) => ({
              key,
              value
            }))
            : [] // fallback if productDetails is missing
        }));

        setProducts(prev => ({
          ...prev,
          data: formattedData,
          loading: false,
          totalRows: formattedData.length,
        }));

        return formattedData;
      } catch (error) {
        setProducts(prev => ({ ...prev, loading: false }));
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Failed to fetch products'
        });
      }
    };

    // Fetch Categories & Subcategories, then Products

    useEffect(() => {
        // Initial fetch on component mount
        const loadInitialData = async () => {
            const freshToken = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : null;
            if (freshToken) {
                console.log('Loading initial products...');
                await fetchProducts();
            } else {
                console.log('No token available');
            }
        };
        
        loadInitialData();
    }, []);



    // const openModal = (type, product = null) => {
    //     setModal({ isOpen: true, type, selectedProduct: product });


    //     setProductDetails(
    //         Array.isArray(product?.productDetails) && product.productDetails.length > 0
    //             ? product.productDetails
    //             : [{ key: "", value: "" }]
    //     );

    //     if (product) {
    //         const weightMatch = product?.weight
    //             ? /^(\d+)([a-zA-Z]+)$/.exec(product.weight)
    //             : null;
    //         const weight = weightMatch ? weightMatch[1] : "";
    //         const weightUnit = weightMatch ? weightMatch[2] : "";

    //         setFormData({
    //             name: product?.name || "",
    //             price: product?.price || "",
    //             originalPrice: product?.originalPrice || "",
    //             stock: product?.stock || "",
    //             description: product?.description || "",
    //             category: product?.category?._id || "",
    //             image: [],
    //             imagePreview: Array.isArray(product?.images) ? product.images : [],
    //             weight,
    //             weightUnit,
    //             weights: product?.weightOptions
    //                 ? product.weightOptions.map(opt => opt.weight)
    //                 : []
    //         });
    //     } else {
    //         resetForm();
    //     }
    // };



    // const closeModal = () => {
    //     setModal({ isOpen: false, type: "add", selectedProduct: null });
    //     resetForm();
    // };

 


  
// toggle best seller
    const handleMarking = async (row) => {
        try {
           const response =  await axios.patch(`${baseURL}/api/product/best-seller/${row._id}`, {}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            console.log("Marking Response:", response.data);
            Swal.fire({
                icon: 'success',
                title: row.isBestSeller ? 'Unmarked as Best Seller' : 'Marked as Best Seller',
                showConfirmButton: false,
                timer: 1500
            });
            fetchProducts();
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to update product status'
            });
        }
    };

    // Delete Product
    const handleDeleteProduct = async (id) => {
        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this product!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        // If user confirmed, proceed with deletion
        if (result.isConfirmed) {
            try {
                await axios.delete(`${baseURL}/api/product/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Product Deleted',
                    showConfirmButton: false,
                    timer: 1500
                });

                // closeModal();
                fetchProducts();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'Failed to delete product'
                });
            }
        }
    };

  const columns = [
  {
    name: 'Image',
    selector: row => row?.images,
 width:"100px",
    left: true,
    cell: row => {
      const firstImage = Array.isArray(row?.images) ? row?.images?.[0] : row?.images;
      return firstImage ? (
        <img
          src={getPublicS3Url(firstImage)}
          alt={row?.name}
          style={{
            width: '60px',
            height: '60px',
            objectFit: 'cover',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
          onClick={() => navigate(`/products/${row?._id}`)}
        />
      ) : (
        <span
          style={{ cursor: 'pointer', color: '#007bff' }}
          onClick={() => navigate(`/products/${row?._id}`)}
        >
          No Image
        </span>
      );
    }
  },
  {
    name: 'Product Name',
    selector: row => row?.name,
    width:"150px",
    sortable: true,
    left: true,
    cell: row => (
      <span
        style={{ cursor: 'pointer', color: '#007bff' }}
        onClick={() => navigate(`/products/${row?._id}`)}
      >
        {row?.name}
      </span>
    ),
  },
  {
    name: 'Category',
    selector: row => row?.category?.name || 'N/A',
    left: true,
    sortable: true,
  },
  {
    name: 'Price (₹)',
    left: true,
    selector: row =>
      row?.sellingType === 'unit'
        ? row?.unitDetails?.price
        : row?.weightDetails?.pricePerKg,
    sortable: true,
  
  },
  {
    name: 'Original Price (₹)',
    width:"160px",
    selector: row =>
      row?.sellingType === 'unit'
        ? row?.unitDetails?.originalPrice
        : row?.weightDetails?.originalPricePerKg,
    sortable: true,
 left: true,
  },
  {
    name: 'Stock',
    selector: row => {
      if (row?.sellingType === 'unit') return row?.unitDetails?.stock || 0;
      if (row?.sellingType === 'weight' && row?.weightDetails?.options?.length) {
        return row?.weightDetails?.options?.reduce(
          (sum, option) => sum + (option?.stock || 0),
          0
        );
      }
      return 0;
    },
    sortable: true,
left: true,
  },
  {
    name: 'Best Seller',
    sortable: false,
    left: true,
    wrap: true,
    cell: row => (
      <div className="line-clamp-2 max-w-xs text-sm text-gray-700">
        {row?.isBestSeller ? "Yes" : "No"}
      </div>
    )
  },
  {
    name: 'Created Date',
    width:"150px",
    selector: row => moment(row?.createdAt).format('DD/MM/YYYY'),
    sortable: true,
    left: true,
  },
  {
    name: "Actions",
    left: true,
    cell: (row) => (
      <div
        className="d-flex justify-content-end align-items-center"
        style={{ marginRight: "20px" }}
      >
        <div className="cursor-pointer">
          <UncontrolledDropdown className="action_dropdown">
            <DropdownToggle className="action_btn">
              <MoreVertical color="#000" size={16} />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => handleMarking(row)}>
                {row?.isBestSeller ? 'Unmark' : 'Mark'} as Best Seller
                <CheckCircle size={15} />
              </DropdownItem>
              <DropdownItem
                onClick={() => navigate(`/product/edit/${row?._id}`)}
              >
                Update
                <FaPen />
              </DropdownItem>
              <DropdownItem
                className="delete_item"
                onClick={() => handleDeleteProduct(row?._id)}
              >
                Delete
                <FaTrashAlt />
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
    ),
    right: true,
  },
];

    const filteredProducts = (products.data || []).filter(item =>
      String(item?.name || "").toLowerCase().includes(String(searchTerm || "").toLowerCase())
    );
    
    console.log('Current State - Page:', products.currentPage, 'PerPage:', products.perPage, 'Data:', filteredProducts);
    
    return (
        <div>
            {/* Header and Search */}
            <Row className="mb-3">
                <Col className="d-flex justify-content-between align-items-center">
                    <h4>Products</h4>
                    <div className="d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control me-2"
                            placeholder="Search products..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ width: '200px' }}
                        />
                        {userRole === 'admin' && (
                            <Button
                                className='btn btn-primary d-flex align-items-center'
                                onClick={() => navigate('/product/create')}
                            >
                                <PlusCircle size={16} className="me-1" /> Add Product
                            </Button>
                        )}
                    </div>
                </Col>
            </Row>

            {/* Data Table */}
            <DataTable
              columns={columns}
              data={filteredProducts}
              progressPending={products.loading}
              progressComponent={<Loader />}
              pagination
              paginationPerPage={products.perPage}
              paginationRowsPerPageOptions={[10, 20, 50, 100]}
              onChangePage={(page) => setProducts(prev => ({ ...prev, currentPage: page }))}
              onChangeRowsPerPage={(newPerPage) => setProducts(prev => ({ ...prev, perPage: newPerPage }))}
            />


            {/* Modal for Add/Edit Product */}
            {/* <Modal
                centered
                isOpen={modal.isOpen && ["add", "edit"].includes(modal.type)}
                toggle={closeModal}
                className="store_modal"
                size="lg"
            >
                <ModalHeader toggle={closeModal}>
                    {modal.type === "add" ? "Add Product" : "Edit Product"}
                </ModalHeader>
                <ModalBody>
                    {/* ✅ use handleSubmit 
                
                </ModalBody>
            </Modal> */}



            {/* Modal for Delete Confirmation */}
            {/* <Modal centered isOpen={modal.isOpen && modal.type === 'delete'} toggle={closeModal}>
                <ModalHeader toggle={closeModal}>Delete Product</ModalHeader>

                <Container>
                    <div className="text-center mb-4">

                        <h5>Are you sure you want to delete this product <span className='font-danger'>{modal?.selectedProduct?.name}</span>?</h5>
                        <p className="text-muted">
                            {/* {modal.selectedProduct.productName} 
                        </p>
                        <p className="text-danger">
                            This action cannot be undone.
                        </p>
                        <Row className="text-center">
                            <Col xs={6}>
                                <Button
                                    type="button"
                                    className="btn btn-secondary w-100"
                                    onClick={closeModal}
                                >
                                    Cancel
                                </Button>
                            </Col>
                            <Col xs={6}>
                                <button
                                    type="button"
                                    className="btn btn-red w-100"
                                    onClick={handleDeleteProduct}
                                    style={{ backgroundColor: '#dc3545', color: '#fff' }}
                                    disabled={products.loading}
                                    data-testid="confirm-delete-button"

                                >
                                    Confirm Delete
                                </button>
                            </Col>
                        </Row>
                    </div>

                    {/* <ModalFooter>
                    <Button color="danger" onClick={handleDeleteProduct}>
                        Confirm Delete
                    </Button>
                    <Button color="secondary" onClick={closeModal}>
                        Cancel
                    </Button>
                </ModalFooter> 
                </Container>
            </Modal> */}
        </div>
    );
};

export default ProductsTable;
